import React from 'react';
import { Modal } from './Modal';
import { ModalHeader } from './ModalHeader';
import { ModalBody } from './ModalBody';
import { ModalFooter } from './ModalFooter';
import { Button, ButtonVariant } from '../Button/Button';
export class DialogModal extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement(Modal, { visible: this.props.visible, style: this.props.style },
                    React.createElement(ModalHeader, null, this.props.title),
                    React.createElement(ModalBody, null, this.props.children),
                    React.createElement(ModalFooter, null,
                        React.createElement(Button, { label: 'Accept', variant: ButtonVariant.Success, onClick: this.props.onAccept }),
                        React.createElement(Button, { label: 'Cancel', variant: ButtonVariant.Danger, onClick: this.props.onCancel })))));
        };
    }
}
